<template>
    <v-app id="inspire">
        <template v-if="checked">
            <layout-aside v-if="activeRoute.aside && !hideAside" v-model="drawer" :width="activeRoute.options.asideWidth">
                <component :is="activeRoute.aside" @continue="onNext"></component>
            </layout-aside>

            <layout-header v-model="drawer" :aside="!!activeRoute.aside && !hideAside"></layout-header>

            <v-content>
                <component :is="activeRoute.default" :options="activeRoute.options"></component>
            </v-content>
        </template>

        <template v-else>
            <v-content>
                <page-loading></page-loading>
            </v-content>
        </template>
    </v-app>
</template>

<script>
    import {mapGetters} from 'vuex'
    import RouterComponents from '@/mixins/router-components.js'
    import LayoutAside from '@/components/layouts/aside'
    import LayoutHeader from '@/components/layouts/header'
    import PageLoading from '@/components/system/page-loading'

    export default {
        mixins: [RouterComponents],
        data: () => ({
            hideAside: false,
            drawer: true,
            checked: false
        }),
        components: {
            LayoutAside,
            LayoutHeader,
            PageLoading
        },
        computed: {
            ...mapGetters('auth', ['isActive']),
            ...mapGetters('progress', ['blockName', 'progress', 'steps'])
        },
        async created () {
            if (!this.isActive) {
                this.$router.push({name: 'main'})
            } else {
                await this.$store.dispatch('profile/fetch')
                this.checked = true
            }
            if (!this.activeRoute) {
                this.$store.dispatch('progress/reset')
            }
        },
        methods: {
            onNext () {
                this.$store.dispatch('testing/next')
            },
            switchStateAside (show) {
                this.hideAside = !show
            }
        },
        mounted () {
            this.$root.$on('aside', this.switchStateAside)
        },
        beforeDestroy () {
            this.$root.$off('aside', this.switchStateAside)
        }
    }
</script>

<style lang="stylus">
    .fill-height {
        height: calc(100vh - 40px);
    }
</style>
